import React from "react";
import { useTranslation } from "react-i18next";
import miodottore from "../../assets/miodottore.png";

const ReserveAppointmentButton: React.FC = () => {
  const { t } = useTranslation();

  const handleClick = () => {
    window.open(
      "https://www.miodottore.it/strutture/odontoiatria-sgarbini?saasonly=true&prevent-patient-app-banner=true&hl=en-IT&gei=VEDpaMLvG8n97_UPk_-wsAc&rwg_token=ACgRB3e2G_vLFmZUbfitPIq8Oezdtd409m7CodsmDlaLajIl1Sflu1tzcZpPo3SZIbN_rBePW4MSIW4Rr2JzsY5uVsLBrHZKhQ%3D%3D#highlight-calendar",
      "_blank"
    );
  };

  return (
    <button
      id="reserve-appointment-button"
      onClick={handleClick}
      className="text-white mt-1 font-semibold  px-4  md:px-6 rounded-lg shadow-lg transform hover:scale-105 transition-all duration-200 text-sm md:text-base whitespace-nowrap"
      style={{
        backgroundColor: "invert(31%) sepia(73%) saturate(1817%) hue-rotate(186deg) brightness(95%) contrast(96%)"
      }}
    >
      <img
        src={miodottore}
        alt="miodottore"
        className="inline-block mr-2 mb-1 w-5"
      />
      <span>{t("cta.bookAppointment")}</span>
    </button>
  );
};

export default ReserveAppointmentButton;
